import type { LanguageKey } from './types.js'

export const allLanguages: LanguageKey[] = [
  'en',
  'es',
  'fr',
  'de',
  'it',
  'pt',
  'ja',
  'ko',
  'zh',
  'hi',
  'bn',
  'th',
  'vi',
  'tr',
  'uk',
  'id',
  'pl',
]
